import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NewInspectionService } from '../../inpsection.service';
//import { InspectionRequestModel, InspectedImplementsViewModel, ReportOptionsVm, WearStatusPackages, AssetDetail } from '../../inspection.model';
import { DomSanitizer } from '@angular/platform-browser';
import { EquipmentDetailsParams } from '../../../setup-equipment/setup-equipment.model';
import { AppService } from '../../../../../app.service';
import { EquipmentDetailsService } from '../../../equipment-details/equipment-details.service';
import { GenericIdName } from '../../../setup-implement/setup-implement.model';
import { NotificationsService } from 'angular2-notifications';
//import { ToastsManager } from 'ng2-toastr/src/toast-manager';
import { InspectedImplementsViewModel, AssetDetail, InspectionRequestModel, ReportOptionsVm, WearStatusPackages } from '../../inspection.model';
import { CryptoService } from '../../../../../services/crypto.service';


@Component({
  selector: 'app-interpretation',
  templateUrl: './interpretation.component.html',
  styleUrls: ['./interpretation.component.scss']
})
export class GETInterpretationComponent implements OnInit {

  equipmentId: number;
  passedDate: string;
  selectedTab: number = 0;
  equipmentDetails: EquipmentDetailsParams;
  loading = false;
  dragged;
  id;
  index;
  indexDrop;
  list;
  inspectedImplements: InspectedImplementsViewModel[];
  //appUris:AppUris;
  inspectionID: number
  onInventory: boolean = false

  None:boolean=false;
  Stage_1:boolean=false;
  Stage_2:boolean=false;
  Stage_3:boolean=false;
  Stage_4:boolean=false;

  AssetDetail:AssetDetail;
  ConfiguartionAtInspectionLevel:boolean;
  ConfiguartionAtAssetLevel:boolean;
  constructor(
    private route: ActivatedRoute,
    private _inspectionService: NewInspectionService,private _equipmentDetailsService: EquipmentDetailsService,
    private _sanitizer: DomSanitizer, private _appService: AppService,
   // private _notify: ToastsManager,
    private _notify: NotificationsService,
    private crypto: CryptoService
  ) { }

  ngOnInit() {

    this.equipmentId = +this.route.snapshot.paramMap.get('equipmentId');
    const year = this.route.snapshot.paramMap.get('year');
    const month = this.route.snapshot.paramMap.get('month');
    const day = this.route.snapshot.paramMap.get('day');
    if (year)
      this.passedDate = new Date(+year, +month - 1, +day).toLocaleDateString('en-US');
    //console.log("this.passedDate: ", this.passedDate);
    this.inspectionID = +this.route.snapshot.paramMap.get('inspectionId');
    this._appService.setPageTitle("Inspection Details");
    //this._appService.getAppUris().subscribe(result => { this.appUris = result; });
    //this._appService.setPageSubTitle("");
    if (this.equipmentId > 0) {
      //this._inspectionService.getEquipmentDetails(this.equipmentId).subscribe(equipment => {
      //  this.equipmentDetails = equipment;
      //});
      this.LoadEquipmentDeatils();
    }
    this.LoadImageRotations();
    this.getGETWearSurfaceReportSyle();
    if (this.equipmentId == 0)
      this.onInventory = true
    //console.log("date: ", year, month, day);
    //console.log("equipmentId: ", this.equipmentId);
    //console.log("this.inspectionID: ", this.inspectionID);
    //if (this.equipmentId > 0 && year) {
    //  //if (this.passedDate) {
    //    this._inspectionService.GetImplementInspectionsByEquipmentIdAndDate(new InspectionRequestModel(this.equipmentId, this.passedDate))
    //      .subscribe(r => {
    //        //console.log(r);
    //        this.inspectedImplements = r;
    //        this.inspectedImplements.map(x => {
    //          this.inspectionID = x.ImplementInspectionId;
    //          x.Components.map(x => {
    //            if (x.ReportGrouping == null) {
    //              x.ReportGrouping == -1;
    //            }
    //          });
    //        });
    //        this.loading = false;
    //        this.loadAllComponentTypesUsed();
    //      });
    //  //}
    //}
    //else if (this.inspectionID > 0) {
    //  //console.log(this.inspectionID)
    //  this._inspectionService.GetImplementInspectionsByInspectionId(this.inspectionID)
    //    .subscribe(r => {
    //      //console.log(r);
    //      this.inspectedImplements = r;
    //      this.inspectedImplements.map(x => {
    //        x.Components.map(x => {
    //          if (x.ReportGrouping == null) {
    //            x.ReportGrouping == -1;
    //          }
    //        });
    //      });
    //      this.loading = false;
    //    });
    //  this.loadAllComponentTypesUsed();

    //}
    this.LoadPageAgain();
    this.GetAssetDetail();
    this.CheckImplementReportConfiqAtInsection();
    //this.CheckImplementReportConfiqAtAsset();
                }

  LoadWearPackageStatus(){

  }

  RefreshReportOption(){
    this._inspectionService.RefreshReportOptionByInspectionId(this.inspectionID).subscribe(res=>{
      if(res== true){
       this.selectedTab==1;
       this.loadAllComponentTypesUsed();
      }
    })
  }

  RefreshInspectionData(){
    this._inspectionService.ReCalculateInspectionByInspectionId(this.inspectionID).subscribe(res=>{
      if(res== true){
       this.selectedTab==1;
       this.LoadPageAgain();
      }
    })
  }

LoadEquipmentDeatils(){
  this._inspectionService.getEquipmentDetails(this.equipmentId).subscribe(equipment => {
    this.equipmentDetails = equipment;
  });
}
  LoadPageAgain(){
    if (this.equipmentId == 0)
    this.onInventory = true;
    const year = this.route.snapshot.paramMap.get('year');
    if (this.equipmentId > 0 && year) {
    //if (this.passedDate) {
      this._inspectionService.GetImplementInspectionsByEquipmentIdAndDate(new InspectionRequestModel(this.equipmentId, this.passedDate))
        .subscribe(r => {
          //console.log(r);
          this.inspectedImplements = r;
          
          this.inspectedImplements.map(x => {
            if (x.Inspector && x.Inspector.length > 0) {
              x.Inspector = this.crypto.decrypt(x.Inspector);
            }
            this.inspectionID = x.ImplementInspectionId;
            x.Components.map(x => {
              if (x.ReportGrouping == null) {
                x.ReportGrouping == -1;
              }
            });
          });
          this.loading = false;
          //this.LoadEquipmentDeatils();
          this.loadAllComponentTypesUsed();
        });
    //}
  }

  if (this.inspectionID > 0) {
    //console.log(this.inspectionID)
    //this._inspectionService.GetImplementInspectionsByInspectionId(this.inspectionID)
    this._inspectionService.GetGeneralInspectionsInfo(this.inspectionID)
      .subscribe(r => {
        //console.log(r);
        this.inspectedImplements = r;
        this.inspectedImplements.map(x => {
          if (x.Inspector && x.Inspector.length > 0) {
            x.Inspector = this.crypto.decrypt(x.Inspector);
          }
        //  x.Components.map(x => {
        //    if (x.ReportGrouping == null) {
        //      x.ReportGrouping == -1;
        //    }
        //  });
        });
        this.loading = false;
      });
    this.loadAllComponentTypesUsed();

  }
  }

  LoadData(index: number) {

    if (index == 1) {
      this.loadAllComponentTypesUsed();
    }
  }
  getImage(image: string) {
    if (image != null && image !== undefined) {
      return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
    }
  }


  getEvalClass(evalNumber: number) {
    return this._inspectionService.getEvalClass(evalNumber);
  }



  allowDrop(ev) {
    ev.preventDefault();
  }

  drag({ target }) {
    //ev.dataTransfer.setData("text", ev.target.id);
    //ev.target.remove


    this.dragged = target;
    this.id = target.id;
    this.list = target.parentNode.children;
    for (let i = 0; i < this.TypesList.length; i += 1) {


      var c = document.getElementById(this.TypesList[i].group_order.toString())

      if (c === this.dragged) {
        this.index = i;
      }
    }

  }

  drop({ target }) {
    // console.log("drop", this.list);

    // ev.preventDefault();
    // var data = ev.dataTransfer.getData("text");
    // ev.target.parentNode.appendChild(document.getElementById(data));

    console.log("target.className", target.className)


    if (target.className == "dropzone" && target.id !== this.id) {
      this.dragged.remove(this.dragged);
      for (let i = 0; i < this.TypesList.length; i += 1) {
        var c = document.getElementById(this.TypesList[i].group_order.toString())

        if (c === target) {


          this.indexDrop = i;
        }
      }

      if (this.index > this.indexDrop) {
        this.dragged.style.margin = "7px 0px 7px 0px";
        target.before(this.dragged);

        let group_order_num_1 = this.TypesList[this.index].group_order
        let group_order_num_2 = this.TypesList[this.indexDrop].group_order


        this.TypesList[this.index].group_order = group_order_num_2
        this.TypesList[this.indexDrop].group_order = group_order_num_1


      } else {
        this.dragged.style.margin = "7px 0px 7px 0px";
        target.after(this.dragged);

        let group_order_num_1 = this.TypesList[this.index].group_order
        let group_order_num_2 = this.TypesList[this.indexDrop].group_order


        this.TypesList[this.index].group_order = group_order_num_2
        this.TypesList[this.indexDrop].group_order = group_order_num_1
      }



    } else if (target.className == "dropzone_child" && target.parentNode.id !== this.id) {
      this.dragged.remove(this.dragged);
      for (let i = 0; i < this.TypesList.length; i += 1) {
        var c = document.getElementById(this.TypesList[i].group_order.toString())

        if (c === target.parentNode) {


          this.indexDrop = i;
        }
      }
      console.log(this.index, this.indexDrop);
      if (this.index > this.indexDrop) {

        let group_order_num_1 = this.TypesList[this.index].group_order
        let group_order_num_2 = this.TypesList[this.indexDrop].group_order
        this.dragged.style.margin = "7px 0px 7px 0px";
        target.parentNode.before(this.dragged);




        this.TypesList[this.index].group_order = group_order_num_2
        this.TypesList[this.indexDrop].group_order = group_order_num_1
      } else {
        this.dragged.style.margin = "7px 0px 7px 0px";
        let group_order_num_1 = this.TypesList[this.index].group_order
        let group_order_num_2 = this.TypesList[this.indexDrop].group_order
        target.parentNode.after(this.dragged);

        this.TypesList[this.index].group_order = group_order_num_2
        this.TypesList[this.indexDrop].group_order = group_order_num_1
      }



    } else if (target.className == "dropzone_child_child" && target.parentNode.parentNode.id !== this.id) {
      this.dragged.remove(this.dragged);
      for (let i = 0; i < this.TypesList.length; i += 1) {
        var c = document.getElementById(this.TypesList[i].group_order.toString())

        if (c === target.parentNode.parentNode) {


          this.indexDrop = i;
        }
      }
      console.log(this.index, this.indexDrop);
      if (this.index > this.indexDrop) {
        this.dragged.style.margin = "7px 0px 7px 0px";
        target.parentNode.parentNode.before(this.dragged);

        let group_order_num_1 = this.TypesList[this.index].group_order
        let group_order_num_2 = this.TypesList[this.indexDrop].group_order


        this.TypesList[this.index].group_order = group_order_num_2
        this.TypesList[this.indexDrop].group_order = group_order_num_1
      } else {
        this.dragged.style.margin = "7px 0px 7px 0px";
        target.parentNode.parentNode.after(this.dragged);

        let group_order_num_1 = this.TypesList[this.index].group_order
        let group_order_num_2 = this.TypesList[this.indexDrop].group_order


        this.TypesList[this.index].group_order = group_order_num_2
        this.TypesList[this.indexDrop].group_order = group_order_num_1
      }



    }
    console.log(this.TypesList);
    //update typelist in database
    this._inspectionService.UpdateGroupOrder(this.TypesList).subscribe(res => {
      console.log("component Types", res)

    })
  }

  TypesList: ReportOptionsVm[] = []

  ImageRotationsList:GenericIdName[] = [];

  LoadImageRotations() {
    this._inspectionService.GetImageRotations().subscribe(res => {
      this.ImageRotationsList = res;
    })
  }
  loadAllComponentTypesUsed() {
    this._inspectionService.GetComponentTypesByInspectionId(this.inspectionID).subscribe(res => {
      //console.log("component Types", res)
      res.map((element,i) => {
        if(element.group_order == null){
         element.group_order = i+1
        }
      });
      this.TypesList = res.sort((a, b) => parseFloat(a.group_order.toString()) - parseFloat(b.group_order.toString()));
      this.None = this.TypesList[0].None;
      this.Stage_1 = this.TypesList[0].Stage1;
      this.Stage_2 = this.TypesList[0].Stage2;
      this.Stage_3 = this.TypesList[0].Stage3;
      this.Stage_4 = this.TypesList[0].Stage4;
    })
  }

  

  // recalculateSortOrderDown(order:number){
  //   this._inspectionService.CompTypeOrderDown(this.inspectionID,order).subscribe((res:any)=>{
  // recalculateSortOrderDown(order:number){
  //     if(res==true){
  //       this.loadAllComponentTypesUsed();
  //     }
  //   })
  // }

  recalculateSortOrderDown(order: number) {
    this._inspectionService.CompTypeOrderDown(this.inspectionID, order).subscribe((res: any) => {
      if (res === true) {
        this.loadAllComponentTypesUsed();
      }
    });
  }
  

  recalculateSortOrderUp(order:number){
    this._inspectionService.CompTypeOrderUp(this.inspectionID,order).subscribe(res=>{
      if(res==true){
        this.loadAllComponentTypesUsed();
      }
    })
  }

  toggleIncludeSummary(Id: number) {
    console.log("toggleIncludeSummary", Id)
    if (Id > 0) {
      this._inspectionService.toggleReportInspectionIncludeSummary(Id).subscribe((r:any) => {
        if (r.m_Item1) {
         // this._notify.success(r.m_Item2);
        } else {
         // this._notify.error(r.m_Item2);
        }
      });
    }
  }
//added by Hans Raj Sharma as on 17 Jan 2023 TT-6788
  toggleIncludeSchematicInSummary(Id: number,event:any,item:ReportOptionsVm) {
    let selectedValue = event.checked;
    if(selectedValue==true){
      item.ShowImageRotation = true;
    }else{
      item.ShowImageRotation=false;
    }
    console.log("toggleIncludeSchematicInSummary", Id,selectedValue)
    if (Id > 0) {
      this._inspectionService.toggleReportInspectionIncludeSchematicInSummary(Id).subscribe((r:any) => {
        if (r.m_Item1) {
         // this._notify.success(r.m_Item2);
        } else {
         // this._notify.error(r.m_Item2);
        }
      });
    }
  }

  toggleIncludeGraph(Id: number) {
    if (Id > 0) {
      this._inspectionService.toggleReportInspectionIncludeGraph(Id).subscribe((r:any) => {
          if (r.m_Item1) {
              //this._notify.success(r.m_Item2);
              this.loadAllComponentTypesUsed();
          } else {
            //  this._notify.error(r.m_Item2);
          }
      });
  }
  }

  UpdatechartType(Id:number, chartType:number){
    if (Id > 0) {
      this._inspectionService.toggleReportInspectionChartType(Id,chartType).subscribe((r:any) => {
          if (r.m_Item1) {
             // this._notify.success(r.m_Item2);
          } else {
             // this._notify.error(r.m_Item2);
          }
      });
    }
  }

  toggleIncludeTable(Id: number) {
    if (Id > 0) {
      this._inspectionService.toggleReportInspectionIncludeDataTable(Id).subscribe((r:any) => {
        if (r.m_Item1) {
          //this._notify.success(r.m_Item2);
        } else {
         // this._notify.error(r.m_Item2);
        }
      });
    }
  }

  toggleIncludeBody(Id: number) {
    if (Id > 0) {
      this._inspectionService.toggleReportInspectionIncludeBody(Id).subscribe((r:any) => {
        if (r.m_Item1) {
         // this._notify.success(r.m_Item2);
        } else {
         // this._notify.error(r.m_Item2);
        }
      });
    }
  }

  ChangeReportEvalOption(Id: number, event: any) {
    let selectedValue = event.value;
    this._inspectionService.UpdateReportComTypeOverallEval(Id, selectedValue).subscribe((r:any) => {
      if (r.m_Item1) {
       // this._notify.success(r.m_Item2);
      } else {
       // this._notify.error(r.m_Item2);
      }
    });

  }

  ChangeReportImageRotationOption(Id: number, event: any) {
    let selectedValue = event.value;
    this._inspectionService.UpdateReportComTypeImageRotation(Id, selectedValue).subscribe((r:any) => {
      if (r.m_Item1) {
       // this._notify.success(r.m_Item2);
      } else {
       // this._notify.error(r.m_Item2);
      }
    });

  }

  commentChanged(Id: number, value: any) {
    this._inspectionService.UpdateReportSummaryComment(Id, value).subscribe((r:any) => {
      if (r.m_Item1) {
      //  this._notify.success(r.m_Item2);
      } else {
       // this._notify.error(r.m_Item2);
      }
    });
  }

  RepaircommentChanged(Id: number, value: any) {
    this._inspectionService.UpdateReportRepairComment(Id, value).subscribe((r:any) => {
      if (r.m_Item1) {
       // this._notify.success(r.m_Item2);
      } else {
        //this._notify.error(r.m_Item2);
      }
    });
  }

  GeneralcommentChanged(Id: number, value: any) {
    this._inspectionService.UpdateReportGeneralComment(Id, value).subscribe((r:any) => {
      if (r.m_Item1) {
        this._notify.success(r.m_Item2);
      } else {
        this._notify.error(r.m_Item2);
      }
    });
  }

  GroupTypeNameChanged(Id: number, value: any) {
    this._inspectionService.UpdateReportGroupName(Id, value).subscribe((r:any) => {
      if (r.m_Item1) {
       // this._notify.success(r.m_Item2);
      } else {
        //this._notify.error(r.m_Item2);
      }
    });
  }

  wearStyleId:number;
  getGETWearSurfaceReportSyle(){
    this._equipmentDetailsService.GetGETWearSurfaceReportStyle(this.equipmentId).subscribe(res=>{
        if(res!= null){
            this.wearStyleId = res;
        }
    })
}
  
  GenerateTrayPDF(date:string){
    //this.date = inspectionDate.toString();
console.log("DATE", this.inspectedImplements[0].InspectionStringDate, this.wearStyleId)
      var dateParts = this.inspectedImplements[0].InspectionStringDate.split('/');
      var months = [
          { id: "01", name: "Jan" },
          { id: "02", name: "Feb" },
          { id: "03", name: "Mar" },
          { id: "04", name: "Apr" },
          { id: "05", name: "May" },
          { id: "06", name: "Jun" },
          { id: "07", name: "Jul" },
          { id: "08", name: "Aug" },
          { id: "09", name: "Sep" },
          { id: "10", name: "Oct" },
          { id: "11", name: "Nov" },
          { id: "12", name: "Dec" }
      ];

      var day = dateParts[0];
      var month = months.find(f => f.name == dateParts[1]).id;
      var year = dateParts[2];

      var dateParsed = year + month + day;

      //window.open(this.appUris.UCUri + 'api/GETinspection/GetTrayPdf?id=' + this.equipmentId  + '&date=' + dateParsed + '&styleId=' + this.wearStyleId, '_blank');
      window.open(this._appService.getBaseURL() + 'api/GETinspection/GetTrayPdf?id=' + this.equipmentId  + '&date=' + dateParsed + '&styleId=' + this.wearStyleId, '_blank');
  
}

changeCheckbox(value:string){

}
  UpdateWearStatusFiled(){
    let params = new WearStatusPackages();
    params.InspectionId = this.inspectionID;
    params.WearNoe = this.None;
    params.Wear_1=this.Stage_1;
    params.Wear_2=this.Stage_2;
    params.Wear_3=this.Stage_3;
    params.Wear_4=this.Stage_4;

    console.log("params__", params)
    
   this._inspectionService.UpdateWearStatusPackage(params).subscribe(res=>{
     if(res){
      //this._notify.success("Update Wear Package Status Fields Sucessfully")
     }else{
    //  this._notify.error("Error saving data")

     }
   })
  }

  GetAssetDetail() {
    this._inspectionService.GetAssetDetail(this.equipmentId,this.inspectionID).subscribe(res => {
      //console.log("component Types", res)
      if(res!=null){
        this.AssetDetail= res;
        //console.log(this.AssetDetail)
      }
      
    })
  }

  CheckImplementReportConfiqAtInsection() {
    this._inspectionService.CheckImplementReportConfiqAtInsection(this.inspectionID).subscribe(res => {
     
      if(res!=null){
        this.ConfiguartionAtInspectionLevel= res;
      }
      
    })
  }

  //CheckImplementReportConfiqAtAsset() {
  //  this._inspectionService.CheckImplementReportConfiqAtAsset(this.inspectionID).subscribe(res => {
     
  //    if(res!=null){
  //      this.ConfiguartionAtAssetLevel= res;
  //     // console.log("this.ConfiguartionAtAssetLevel",this.ConfiguartionAtAssetLevel);
  //    }
      
  //  })
  //}

  FillComponentTypeReportConfigurations() {
    this._inspectionService.FillComponentTypeReportConfigurations(this.inspectionID).subscribe(res => {
     
      if(res){
        //this.CheckImplementReportConfiqAtAsset();
        this._notify.success('Success', 'Report Configuration Saved Successfully.');
      }
      
    })
  }
}
